// These must be the first lines in src/index.js
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom"
import AzureAD from "react-aad-msal";
import { authProvider} from "./store/AuthProvider";
import { Provider } from "react-redux"
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import "./i18n";
import rootReducer from './store/reducers/rootReducer'
import './index.module.css';
import './sass/custom.css';
import App from "./App";
import firebase from "./firebase";

firebase.analytics();

const composeEnhancers = (`${process.env.NODE_ENV}` === "development" ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) || compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);
if (process.env.REACT_APP_BUILD_ENVIRONMENT.toLowerCase() === "production") { 
	console.log = () => {};
}
const app = (
  <Provider store={store}>
    <BrowserRouter>
      {/* <AzureAD provider={authProvider} reduxStore={store} forceLogin={true}> */}
        <App />
      {/* </AzureAD> */}
    </BrowserRouter>
  </Provider>
)
ReactDOM.render(
  app,
  document.getElementById('root')
);
